
/**
 * Module dependencies.
 */

import { QueryObserverBaseResult, UseQueryOptions, useQuery } from 'react-query';
import { fetchConfigurations } from './fetch-configurations';

/**
 * Export `ConfigurationsData` type.
 */

export type ConfigurationsData = {
  complainBookUrl: string | null | undefined,
  complimentBookUrl: string | null | undefined,
  emailSupport: string,
  facebook: string | null | undefined,
  instagram: string | null | undefined,
  linkedin: string | null | undefined,
  ogImage: { fileUrl: string } | null | undefined,
  openingHours: string | null | undefined,
  pinterest: string | null | undefined,
  ratingCount: string | null | undefined,
  ratingValue: string | null | undefined,
  vimeo: string | null | undefined,
  wikipedia: string | null | undefined,
  youtube: string | null | undefined
};

/**
 * `Prpos` type.
 */

type Props = QueryObserverBaseResult<ConfigurationsData, unknown>;

/**
 * `Options` type.
 */

type Options = UseQueryOptions<any, unknown, any, "site-configurations">

/**
 * Default stale time.
 *
 * Site configuration is near static and is read by the footer and the menu on
 * every page.
 */

const defaultStaleTime = 30 * 60 * 1000;

/**
 * Action type.
 */

const actionType = 'site-configurations';

/**
 * `useConfigurations` hook.
 */

function useConfigurations(options?: Options): Props {
  const result = useQuery(actionType, () => fetchConfigurations(), {
    staleTime: defaultStaleTime,
    ...options
  });

  return result;
}

/**
 * Export `useConfigurations` hook.
 */

export default useConfigurations;
